import { Dropdown } from '@digdir/designsystemet-react';

import styled from '../../../../styled';

const CardContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--ds-size-4);
  align-items: center;
`;

const CardContentColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const DropDownButton = styled(Dropdown.Button)`
  border-radius: var(--ds-border-radius-sm);
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

const ImprovementIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--ds-size-2);
`;

export { CardContentRow, CardContentColumn, DropDownButton, Content, ImprovementIndicatorWrapper };
